import { FormError } from "@3gaam/shared/types/error";
import React from "react";
import { NumericFormat, NumericFormatProps } from "react-number-format";
import Icon from "../icon";

type Props = Omit<NumericFormatProps, "onChange"> & {
  error?: FormError;
  icon?: string;
  iconContent?: React.ReactNode;
  onChange?: (e: any, param?: any) => void;
};

const NumberField = ({
  onChange,
  onKeyDown,
  name,
  value,
  prefix,
  placeholder,
  className,
  decimalScale,
  readOnly,
  icon,
  iconContent,
  error,

  ...props
}: Props) => {
  let showError = name && error?.hasError && error?.dataError?.[name];
  return (
    <>
      <div className={`inp-box ${showError ? "invalid-field" : ""}`}>
        {iconContent ? (
          iconContent
        ) : icon ? (
          <span className="inp-icon">
            <Icon name={icon} />
          </span>
        ) : (
          <></>
        )}
        <NumericFormat
          className={`form-control ${icon ? "pl-5" : ""} ${className}`}
          inputMode="numeric"
          value={value}
          name={name}
          onChange={onChange}
          prefix={prefix}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          readOnly={readOnly}
          decimalScale={decimalScale}
          {...props}
        />
      </div>
      {showError && name && (
        <p className="text-red font-10 mt-1">{error?.dataError?.[name]}</p>
      )}
    </>
  );
};

NumberField.defaultProps = {
  onChange: undefined,
  onKeyDown: undefined,
  name: undefined,
  value: undefined,
  prefix: undefined,
  format: undefined,
  placeholder: undefined,
  className: undefined,
  decimalScale: undefined,
  icon: undefined,
  iconContent: undefined,
  readOnly: undefined,
  error: undefined,
};

export default NumberField;
